"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Sean sean.snow@live.com
 * @date 2015/12/27
 */

var Arrays = (function () {
    function Arrays() {
        _classCallCheck(this, Arrays);
    }

    _createClass(Arrays, null, [{
        key: "copyOf",
        value: function copyOf(original, newLength) {
            var copy = new Array(newLength);
            Arrays.arraycopy(original, 0, copy, 0, Math.min(original.length, newLength));
            return copy;
        }
    }, {
        key: "arraycopy",
        value: function arraycopy(src, srcPos, dest, destPos, length) {
            var tmp = src.slice(srcPos);
            for (var i = destPos; i < destPos + length; i++) {
                dest[i] = tmp[i - destPos];
            }
        }
    }]);

    return Arrays;
})();

exports.default = Arrays;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdk/util/Arrays.js
// module id = 11
// module chunks = 0